<template>
    <div>
        <skupovi-navigation
                :id="skup_id"
                :breadcrumbs="breadcrumbs"
        >
        </skupovi-navigation>
        <div class="ibox ">
            <div class="ibox-title">
                <h5>Podteme</h5><br>
                <button
                        type="button"
                        class="btn btn-lg btn-primary"
                        @click.prevent="create"
                >
                    Novi unos
                </button>
            </div>
            <div class="ibox-content">
                <datatables
                        v-if="show_datatable"
                        :url="datatables_url"
                        :settings="datatables.settings"
                        :title="datatables.title"
                        @rowClick="rowClick"
                >
                </datatables>
            </div>
        </div>
    </div>

</template>

<script>
import Datatables from "@/components/datatable/Datatables";
import SkupoviNavigation from "@/views/pages/Skupovi/SkupoviNavigation";
import axios from "axios";

export default {
    name: "SkupoviTeme2",
    components: {
        Datatables,
        SkupoviNavigation
    },
    data(){
        return {
            show_datatable: false,
            datatables_url: process.env.VUE_APP_API_URL +  'skup-tema2',
            datatables: {},
            breadcrumbs: [],
            skup_id: this.$route.params.skup_id
        }

    },
    methods:{
        rowClick( row ){
            this.$router.push( { path: '/skupovi/' + this.skup_id + '/podteme/' + row.id } )
        },

        create(){
            this.$router.push( { path: '/skupovi/' + this.skup_id + '/podteme/create' } )
        },

        setDatatable() {
            let vm = this;
            vm.datatables = {
                settings: {
                    table_header:[
                        {
                            'id': 'id',
                            'visible': false,
                        },
                        {
                            'id': 'skup_id',
                            'visible': false,
                            'filter':{
                                'type': 'none',
                                'value': vm.skup_id
                            },
                        },
                        {
                            'id': 'skup_tema_id',
                            'title': 'Tema',
                            'type': function ( row ) {
                                return row.skupovi_teme.naziv
                            },
                            'filter': {
                                'type': 'select',
                                'search': function ( ){
                                    let component = this;

                                    axios.get( process.env.VUE_APP_API_URL +  'skup-tema', {
                                        params: {
                                            order: 'asc'
                                        }
                                    })
                                        .then( function ( response ) {
                                            let tmp = [];
                                            response.data.data.forEach( function ( item ) {
                                                tmp.push({
                                                    key: item.id,
                                                    value: item.naziv
                                                } );
                                            } );
                                            component.$data.tmp = tmp;
                                        } )
                                        .catch( function ( error ) {
                                            if(error instanceof Error) {
                                                console.log( 'Error: ' . error);
                                            } else {
                                                console.log( 'Unexpected response: ' . error);
                                            }
                                        } )
                                },
                                'value': null
                            },
                            'column_visibility_group': {
                                id: 'tema2',
                            }
                        },
                        {
                            'id': 'broj_teme2',
                            'title': 'Broj podteme',
                            'searchable': false,
                            'column_visibility_group': {
                                id: 'tema2',
                            }
                        },
                        {
                            'id': 'naziv',
                            'title': 'Naziv',
                            'column_visibility_group': {
                                id: 'tema2',
                            }
                        },
                        {
                            'id': 'predavaci',
                            'title': 'Predavači',
                            'column_visibility_group': {
                                id: 'predavaci',
                            }
                        },
                        {
                            'id': 'datum_od',
                            'title': 'Početak',
                            'searchable': false,
                            'column_visibility_group': {
                                id: 'tema2',
                             }
                        },
                        {
                            'id': 'datum_do',
                            'title': 'Završetak',
                            'searchable': false,
                            'column_visibility_group': {
                                id: 'tema2',
                            }
                        },

                    ],
                    column_visibility_groups:{
                        'tema2' : 'Podteme'
                    },
                    order: 'desc',
                    order_by: 'id',
                },
                title: 'Podteme',
            }
            vm.show_datatable = true;
        },

        setBreadcrumbs(){
            this.breadcrumbs = [
                {
                    path: '/skupovi/' + this.skup_id + '/podteme',
                    name: 'Podteme'
                }
            ]
        }
    },
    mounted() {
        this.setDatatable()
        this.setBreadcrumbs()
    }
}
</script>

<style scoped>

</style>
